import * as React from 'react';
import {connect} from 'react-redux';

import type {LeadStage, FormattedValue} from 'nutshell-core/types';
import {VisualPipeline} from 'nutshell-core/visual-pipeline';

import type {NutshellState} from '../../../store';

import {ChevronBorder} from '../../lead/shared/components';

import styles from './visual-pipeline-column-header.module.css';

const mapStateToProps = function (state: NutshellState, ownProps: OwnProps): StateProps {
    const stageId = ownProps.stage.id;

    return {
        count: VisualPipeline.getLeadCountForStage(stageId)(state),
        value: VisualPipeline.getTotalValueForStage(stageId)(state),
    };
};

type OwnProps = {
    stage: LeadStage;
    isLastChild: boolean;
    zIndex: number;
};

type StateProps = {
    count: number;
    value: FormattedValue;
};

type Props = OwnProps & StateProps;

export class VisualPipelineColumnHeaderComponent extends React.PureComponent<Props> {
    render() {
        return (
            <div style={{zIndex: this.props.zIndex}} className={styles.container}>
                {!this.props.isLastChild ? <ChevronBorder side='right' /> : undefined}
                <div className={styles['left-container']}>
                    <div data-tip={this.props.stage.name} className={styles['stage-name']}>
                        {this.props.stage.name}
                    </div>
                    <div className={styles['stage-count']}>{this.props.count}</div>
                </div>
                <div className={styles['right-container']}>
                    <div className={styles['stage-value']}>
                        {this.props.value.prefix}
                        {this.props.value.formatted}
                        {this.props.value.suffix}
                    </div>
                </div>
            </div>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);
export const VisualPipelineColumnHeader = connector(VisualPipelineColumnHeaderComponent);
